import { $http } from "@/plugins/api";

const defaultUsersState = () => {
  return {
    users: [],
    usersTotal: 0,
    selectedUser: null,
    selectedTier: null,
    selectedTierId: null,
    azureUsers: [],
    azureUsersTotal: 0,
    antispoofUsers: [],
    antispoofUsersTotal: 0,
  };
};
const state = defaultUsersState();

const getters = {
  getUsers: (state) => state.users,
  getUsersTotal: (state) => state.usersTotal,
  selectedUserAccount: (state) => state.selectedUser,
  getSelectedTierId: (state) => state.selectedTierId,
  selectedUser: (state) => state.selectedUser,
  getAzureUsers: (state) => state.azureUsers,
  getAzureUsersTotal: (state) => state.azureUsersTotal,
  getAntispoofUsers: (state) => state.antispoofUsers,
  getAntispoofUsersTotal: (state) => state.antispoofUsersTotal,
};

const actions = {
  clearUsersCache({ commit }) {
    commit("resetState");
  },
  // TODO: remove updateUser() when the new administrators edit is available for the customers:
  async updateUser({ commit }, formData) {
    const rs = await $http.patch(
      `${import.meta.env.VITE_API_CLIENT}/v1/idp/users/${formData.uuid}`,
      {
        name: formData.formData.name,
        email: formData.formData.email,
        password: formData.formData.password,
      },
    );
    commit("updateUser", rs.data);
  },
  async updateAdministratorUser(_, formData) {
    await $http.patch(
      `${import.meta.env.VITE_API_CLIENT}/v1/idp/users/${formData.uuid}`,
      {
        name: formData.formData.name,
        email: formData.formData.email,
        password: formData.formData.password,
        roles: formData.formData.roles,
      },
    );
  },

  async getUserList({ commit }, { organisation_uuid, params }) {
    const baseUrl = `${import.meta.env.VITE_API_CLIENT}/v1/idp/users`;
    const url = new URL(baseUrl);

    const searchParams = new URLSearchParams({ organisation_uuid, ...params });
    url.search = searchParams.toString();

    const response = await $http.get(url.toString());

    commit("setUsers", response.data);
    commit("setUsersTotal", response.data);
  },
  async deleteUsers({ commit }, { users }) {
    const response = await $http.delete(
      `${import.meta.env.VITE_API_CLIENT}/v1/idp/users/${users[0].uuid}`,
    );

    commit("deleteUsers", [response.data.uuid]);
    return response;
  },
  async createUser({ commit }, { uuid, formData }) {
    const userResponse = await $http.post(
      `${import.meta.env.VITE_API_CLIENT}/v1/idp/users`,
      {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        organisation_uuid: uuid,
        roles: ["admin"],
      },
    );
    commit("updateUser", userResponse.data);
    return userResponse;
  },

  async fetchAntispoofUsers({ commit }, { uuid, params }) {
    const baseUrl = `${import.meta.env.VITE_API_CLIENT}/v1/antispoof/users`;
    const url = new URL(baseUrl);
    const reqParams = new URLSearchParams(params);

    reqParams.set("organisation_uuid", uuid);
    url.search = reqParams.toString();

    const { data } = await $http.get(url.toString());

    commit("setAntispoofUsers", data.data);
    commit("setAntispoofUsersTotal", data.total);
  },

  async azureUsers({ commit }, { id, filter }) {
    const azureUsers = await $http.get(
      `${import.meta.env.VITE_API_CLIENT}/v1/pt/users?organisationID=${id}&top=999&filter=${filter}`,
      { _hasCustomErrorHandling: true },
    );
    commit("setAzureUser", azureUsers.data.users);
    commit("setAzureUsersTotal", azureUsers.data.metadata?.total || 0);
  },
  async getUser({ commit }, uuid) {
    const id = uuid.uuid;
    const rs = await $http.get(
      `${import.meta.env.VITE_API_CLIENT}/v1/idp/users/${id}`,
    );
    commit("setselectedUser", rs.data);
    return rs.data;
  },
};

const mutations = {
  resetState(state) {
    Object.assign(state, defaultUsersState());
  },
  setUsers: (state, data) => (state.users = data.data),
  setUsersTotal: (state, data) => (state.usersTotal = data.total),
  setAzureUser: (state, data) => (state.azureUsers = data),
  setAzureUsersTotal: (state, data) => (state.azureUsersTotal = data),
  setAntispoofUsers: (state, data) => (state.antispoofUsers = data),
  setAntispoofUsersTotal: (state, data) => (state.antispoofUsersTotal = data),
  updateUser: (state, data) => state.users.push(data),
  setselectedUser: (state, data) => (state.selectedUser = data),
  setSelectedTier: (state, data) => (state.selectedTier = data),
  setSelectedTierId: (state, data) => (state.selectedTierId = data),
  deleteUsers(state, ids) {
    for (const id of ids) {
      state.users = state.users.filter((user) => user.uuid !== id);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
